<button (click)="onButtonClick()" [ngClass]="btnClass" [disabled]="disabled">
  {{ textContent }}
  <ng-content />
</button>
